/**
 * Global brand theme — MCC (mcc branch).
 * Use these tokens everywhere. Do not hardcode brand colors in components.
 */

export const brand = {
  id: "mcc",
  name: "MCC",
  pageTitle: "MCC — Marketing Call Center",
  logoUrl: "/mcc-logo.png",
  logoWhiteUrl: "/mcc-logo.png",
  iconUrl: "/favicon.png",
  /** Full-color logo — do not invert on dark chrome */
  invertOnDark: false,

  features: {
    medications: false,
    pathologies: false,
  },

  colors: {
    accent: "#F89339",
    accentHover: "#D97A22",
    accentSoft: "rgba(248, 147, 57, 0.14)",
    accentRing: "rgba(248, 147, 57, 0.24)",
    accentBorder: "rgba(248, 147, 57, 0.42)",
    ink: "#1A1A1A",
    muted: "#5C6470",
    line: "rgba(26, 26, 26, 0.14)",
    surface: "#FFFFFF",
    surfaceSoft: "rgba(255, 255, 255, 0.92)",
    bg: "#FAFAF8",
    bgElevated: "#FFFFFF",
    critical: "#E30613",
    criticalSoft: "rgba(227, 6, 19, 0.12)",
    onAccent: "#1A1A1A",
    secondary: "#FDDE65",
  },

  fonts: {
    display: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif',
    body: 'Poppins, "Helvetica Neue", Helvetica, Arial, sans-serif',
  },

  radius: {
    sm: "0",
    md: "0",
    lg: "0",
    xl: "0",
    pill: "999px",
  },

  iconFilters: {
    muted:
      "brightness(0) saturate(100%) invert(35%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)",
    accent:
      "brightness(0) saturate(100%) invert(67%) sepia(62%) saturate(1128%) hue-rotate(339deg) brightness(99%) contrast(96%)",
    ink: "brightness(0) saturate(100%) invert(8%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)",
    onAccent: "brightness(0) saturate(100%) invert(8%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(95%) contrast(90%)",
  },
};

export default brand;
